import { COLORS } from '@/styles/tokens/colors';

import { RENDER_CONFIG } from './householdLoadingGraph.config';
import { GraphRole } from './householdLoadingGraph.types';
import { householdLoadingNodeRadius } from './householdLoadingGraphLayout';

/** A node's visual mark; its parent group owns its animated position. */
export function HouseholdLoadingGraphNode({
  role,
  color,
  index,
}: {
  role: GraphRole;
  color: string;
  index: number;
}) {
  return (
    <g
      className="graph-reveal"
      style={{ animationDelay: `${Math.min(index, 9) * 70}ms` }}
    >
      {role === 'hub' && (
        <circle
          className="graph-halo"
          r={RENDER_CONFIG.HUB_HALO_RADIUS}
          fill={color}
          fillOpacity={0.1}
        />
      )}
      <circle
        r={householdLoadingNodeRadius(role)}
        fill={role === 'hub' ? COLORS.PRIMITIVES.WHITE : color}
        fillOpacity={role === 'minor' ? RENDER_CONFIG.MINOR_OPACITY : 1}
        stroke={color}
        strokeWidth={role === 'hub' ? 1.2 : 0}
      />
      {role === 'hub' && <circle r={2} fill={color} />}
    </g>
  );
}
